import * as React from "react";
import type { SVGProps } from "react";
const SvgLightning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.967 3 4.75 14H12l-.967 7 8.217-11H12z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLightning;
